import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LeadIntent } from '../api/models';
import { LeadIntentService } from '../api/services';
import { State } from '../store/interfaces';
import {
  loadIntentErrorAction,
  loadIntentRequestAction,
  loadIntentSuccessAction,
} from '../store/reducers/leadIntent';
import { StatusCodes } from 'http-status-codes';

export const useLeadIntent = (leadIntentService: LeadIntentService) => {
  const intent = useSelector((state: State) => state.leadIntent);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadIntent = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadIntentRequestAction());
    try {
      const response = await leadIntentService.loadAllIntent();

      return dispatch(loadIntentSuccessAction(response));
    } catch (error) {
      return dispatch(loadIntentErrorAction());
    }
  };

  const updateIntent = async (
    data: LeadIntent,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadIntentService.updateIntent(data, id);

      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  return {
    loadIntent,
    updateIntent,
    updating,
    updateError,
  };
};
